import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "./LanguageContext";
import { Reveal } from "./Reveal";
import { IznikTexture, IznikRosette } from "./Motifs";

export default function KinaSection() {
  const { t } = useLanguage();
  const k = t.kina;

  return (
    <section
      data-testid="kina-section"
      className="relative bg-turq py-28 md:py-40 overflow-hidden text-center"
    >
      <IznikTexture dark size={300} opacity={0.1} />
      <IznikRosette
        className="pointer-events-none absolute -right-24 -top-24 w-[380px] h-[380px] opacity-[0.12]"
        color="#FFFFFF"
        accent="#C5A059"
      />
      <IznikRosette
        className="pointer-events-none absolute -left-28 -bottom-28 w-[420px] h-[420px] opacity-[0.10]"
        color="#FFFFFF"
        accent="#FF5E8E"
      />

      <div className="relative z-10 mx-auto max-w-3xl px-6">
        <Reveal>
          <span className="font-sans text-xs uppercase tracking-[0.34em] text-blush">
            07 — {k.kicker}
          </span>
          <h2 className="mt-5 font-display text-6xl md:text-8xl lg:text-9xl leading-[0.9] tracking-tight text-cream">
            {k.title}
          </h2>
          <span className="mx-auto mt-8 block h-px w-16 bg-gold/60" />
          <p className="mx-auto mt-7 max-w-md font-sans text-base md:text-lg text-cream/80">
            {k.desc}
          </p>

          <motion.a
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
            href="https://www.emrevenur.com"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="kina-website-button"
            className="group mt-10 inline-flex items-center gap-3 rounded-full bg-cream px-8 py-4 text-ink transition-colors duration-300 hover:bg-gold hover:text-cream"
          >
            <span className="font-sans text-sm uppercase tracking-[0.14em]">
              {k.button}
            </span>
            <ArrowUpRight
              className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              strokeWidth={1.8}
            />
          </motion.a>
        </Reveal>
      </div>
    </section>
  );
}
